import React from 'react';
import { Badge } from '../ui/badge';

export default function ConfidenceBadge({ score, showScore = true, size = 'sm' }) {
  if (score === null || score === undefined) return null;

  const numScore = typeof score === 'string' ? parseFloat(score) : score;
  let level, label, styles;

  if (numScore >= 0.85) {
    level = 'high'; label = 'High';
    styles = { bg: 'bg-teal-50', text: 'text-teal-700', dot: 'bg-teal-500' };
  } else if (numScore >= 0.5) {
    level = 'medium'; label = 'Medium';
    styles = { bg: 'bg-amber-50', text: 'text-amber-700', dot: 'bg-amber-500' };
  } else {
    level = 'low'; label = 'Low';
    styles = { bg: 'bg-red-50', text: 'text-red-600', dot: 'bg-red-500' };
  }

  return (
    <Badge
      variant="outline"
      className={`${styles.bg} ${styles.text} border-transparent gap-1.5 font-medium
        ${size === 'xs' ? 'text-[10px] px-1.5 py-0' : 'text-xs px-2 py-0.5'}`}
      data-testid={`confidence-badge-${level}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${styles.dot}`} />
      {label}{showScore && <span className="tabular-nums ml-0.5">{Math.round(numScore * 100)}%</span>}
    </Badge>
  );
}
